module.exports = __webpack_public_path__ + "static/media/angle-right-b.aa521120.svg";